import { captureException as captureException$1 } from '@sentry/react';

function captureException(exception, hint) {
  return captureException$1(exception, hint);
}

export { captureException };
//# sourceMappingURL=captureException.mjs.map
